export default __webpack_public_path__ + "static/media/vietnam.02a173af.svg";